import { createNumberMask } from 'text-mask-addons';

export const numberMask = createNumberMask({ prefix: '' });
